"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spotGroupComponent = exports.SpotGroupComponent = void 0;
const app_1 = require("app");
const PreviewBox_1 = require("../PreviewBox/PreviewBox");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
class SpotGroupComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.spot-two_plus_one .spot-link';
    }
    OnInit() {
        this.el.forEach(el => {
            const href = el.getAttribute('href');
            const playButtonAriaLabel = el.getAttribute('data-play-button-aria-label');
            const popupAriaLabel = el.getAttribute('data-popup-aria-label');
            const closeButtonAriaLabel = el.getAttribute('data-close-button-aria-label');
            if (!app_1.VideoService.checkIsValidVideo(href)) {
                return true; // go to next iteration
            }
            el.addEventListener('click', event => {
                event.preventDefault();
            });
            const playButton = SpotGroupComponent.createPlayButton(playButtonAriaLabel);
            playButton.addEventListener('click', () => {
                (0, PreviewBox_1.renderPreviewBox)(href, popupAriaLabel, closeButtonAriaLabel);
            });
            playButton.addEventListener('keypress', event => {
                if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
                    (0, PreviewBox_1.renderPreviewBox)(href, popupAriaLabel, closeButtonAriaLabel);
                }
            });
            el.querySelector('.spot-image-container').appendChild(playButton);
        });
    }
    static createPlayButton(playButtonAriaLabel) {
        const button = document.createElement('button');
        button.setAttribute('class', 'play-video-button text-primary bg-fill-primary border-primary group-hover:bg-fill-primary-hovered group-active:bg-fill-primary-pressed p-sm m-md md:m-3xl absolute bottom-0 left-0 flex items-center justify-center rounded-2xl border z-[1]');
        button.setAttribute('aria-label', playButtonAriaLabel);
        const icon = MosaicIcon_1.MosaicIconFactory.createIcon('play-arrow-outline', 'mb-[-2px]');
        button.appendChild(icon);
        return button;
    }
}
exports.SpotGroupComponent = SpotGroupComponent;
exports.spotGroupComponent = new SpotGroupComponent();
